import DataTable from "react-data-table-component";
import { Card, CardBody, CardHeader } from "../../../components/card/card";
import React from "react";
import Moment from "moment/moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useEffect, useState } from "react";
import { analytics } from "../../../api";
import { DateRange } from "../../../components/DateRange";
import { endOfDay, startOfDay, subMonths } from "date-fns";
import {
  formatDateOnly,
  formatNumber,
  Loader,
  printLocation,
} from "../../../utils/helper";
import { useNavigate } from "react-router-dom";

function Team({ locationId }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [completedWoPerDay, setCompletedWoPerDay] = useState([]);
  const [totalCostForecasted, setTotalCostForcasted] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [countPartUsed, setCountPartUsed] = useState(0);
  const [countPartForecasted, setCountPartForecasted] = useState(0);
  const [allParts, setAllParts] = useState([]);
  const [workOrderCreated, setWorkOrderCreated] = useState([]);
  // change start date to last week
  const [date, setDate] = useState({
    startDate: subMonths(new Date(), 1),
    endDate: new Date(),
  });
  const gotoWorkOrder = (id) => {
    navigate(`/work-order/detail/${id}`);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await analytics.getPartAnalytics({
        location_id: locationId,
        start_date: date.startDate
          ? Moment(date.startDate).format("YYYY-MM-DD")
          : null,
        end_date: date.startDate
          ? Moment(date.endDate).format("YYYY-MM-DD [23:59:59]")
          : null,
      });
      setLoading(false);
      if (res.ok) {
        const body = await res.json();
        const data = body.data;
        const parts = [];
        let totalForcasted = 0;
        let totalCompletedCost = 0;
        let countCompleted = 0;
        let countCreated = 0;
        data.forEach((item) => {
          item.inventories.forEach((inventory) => {
            totalForcasted +=
              inventory.quantity * inventory.inventory?.part?.part_cost;
            countCreated += inventory.quantity;
            if (item.status.toLowerCase() === "completed") {
              totalCompletedCost +=
                inventory.quantity * inventory.inventory?.part?.part_cost;
              countCompleted += inventory.quantity;
              if (
                parts.find((part) => part.id === inventory.inventory?.part?.id)
              ) {
                const index = parts.findIndex(
                  (part) => part.id === inventory.inventory?.part?.id
                );
                parts[index].quantity += inventory.quantity;
                parts[index].workOrders.push({
                  id: item.id,
                  status: item.status,
                  title: item.title,
                  quantity: inventory.quantity,
                });
              } else {
                parts.push({
                  id: inventory.inventory?.part?.id,
                  quantity: inventory.quantity,
                  location: inventory.inventory?.location?.id,
                  location_name: inventory.inventory?.location?.location_name,
                  part_name: inventory.inventory?.part?.part_name,
                  part_number: inventory.inventory?.part?.part_number,
                  cost: inventory.inventory?.part?.part_cost,
                  workOrders: [
                    {
                      id: item.id,
                      status: item.status,
                      title: item.title,
                      quantity: inventory.quantity,
                    },
                  ],
                });
              }
            }
            // change the part only one part id,
            // so the quantity will be sum up ND ADD WORK ORDER as array
          });
        });
        setAllParts(parts);
        setTotalCostForcasted(totalForcasted);
        setTotalCost(totalCompletedCost);
        setCountPartUsed(countCompleted);
        setCountPartForecasted(countCreated);
        // group completed Work Order by Day
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    fetchData();
  }, [date]);
  const handleChangeDate = (startDate, endDate) => {
    setDate({
      startDate,
      endDate,
    });
  };
  const columns = [
    {
      name: "Part Name",
      selector: (row) => row.part_name,
      minWidth: "150px",
    },
    {
      name: "Part Number",
      selector: (row) => row.part_number,
    },
    {
      name: "Inventory Location",
      selector: (row) => row.location_name,
    },
    {
      name: "Price / Unit",
      selector: (row) => row.cost,
      cell: (row) => {
        return `$${formatNumber(row.cost)}`;
      },
    },
    {
      name: "Total Consumption",
      selector: (row) => row.quantity,
    },
    {
      name: "Total Cost",
      selector: (row) => row.cost * row.quantity,
      cell: (row) => {
        return `$${formatNumber(row.cost * row.quantity)}`;
      },
    },
  ];

  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <table className="table table-stripped table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Work Order</th>
                  <th>Work Order Status</th>
                  <th>Quantity</th>
                  <th>Total Labor Cost</th>
                  <th>Total Part Cost</th>
                  <th>Total Other Cost</th>
                </tr>
              </thead>
              <tbody>
                {data.workOrders.map((workOrder, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <a
                        href="#"
                        onClick={() => {
                          gotoWorkOrder(workOrder.id);
                        }}
                      >
                        {workOrder.title}
                      </a>
                    </td>
                    <td>{workOrder.status}</td>
                    <td>{workOrder.quantity}</td>
                    <td>{workOrder.quantity}</td>
                    <td>${formatNumber(data.cost * workOrder.quantity)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </CardBody>
        </Card>
      </div>
    );
  };

  return (
    <div>
      <div className="row mb-3">
        <div className="col-12 col-md-3">
          <DateRange
            onChange={handleChangeDate}
            startDate={date.startDate}
            endDate={date.endDate}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-3">
          <Card className="bg-theme border-theme bg-opacity-25 mb-3">
            <CardHeader className="border-theme">
              <div style={{ textAlign: "center" }}>
                <h5>Total Labor Cost</h5>
              </div>
            </CardHeader>
            <CardBody>
              <div style={{ textAlign: "center" }}>
                <h1>-</h1>
                <div>Total Labor Cost</div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-12 col-md-3">
          <Card className="bg-theme border-theme bg-opacity-25 mb-3">
            <CardHeader className="border-theme">
              <div style={{ textAlign: "center" }}>
                <h5>Total Parts Cost</h5>
              </div>
            </CardHeader>
            <CardBody>
              <div style={{ textAlign: "center" }}>
                <h1>${formatNumber(totalCost)}</h1>
                <div>Parts Consumption</div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-12 col-md-3">
          <Card className="bg-theme border-theme bg-opacity-25 mb-3">
            <CardHeader className="border-theme">
              <div style={{ textAlign: "center" }}>
                <h5>Other Cost</h5>
              </div>
            </CardHeader>
            <CardBody>
              <div style={{ textAlign: "center" }}>
                <h1>-</h1>
                <div>Other Cost</div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-12 col-md-3">
          <Card className="bg-theme border-theme bg-opacity-25 mb-3">
            <CardHeader className="border-theme">
              <div style={{ textAlign: "center" }}>
                <h5>Total</h5>
              </div>
            </CardHeader>
            <CardBody>
              <div style={{ textAlign: "center" }}>
                <h1>${formatNumber(totalCost)}</h1>
                <div>Total</div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-12">
          <h4>Cost Consumption</h4>
          <div className="mb-3">
            <Card>
              <CardBody>
                <Loader loading={loading}>
                  <DataTable
                    highlightOnHover
                    expandableRows
                    expandableRowsComponent={ExpandedComponent}
                    theme="dark"
                    columns={columns}
                    data={allParts}
                    pagination
                  />
                </Loader>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Team;
